module.exports = __webpack_public_path__ + "img/baleno-glx-midnight-black.ffb8a7c2.png";